export default __webpack_public_path__ + "static/media/4c9288e48b4694850f775f175b6bb0de.svg";